<template>
    <Modal :cancel="cancel"
           :ok="ok"
           ok-label="ORDER_EMAIL_RECEIPT_MODAL.SEND"
           :ok-enabled="okEnabled"
           :ok-spinner="sending"
           icon="fa-envelope-open-text"
           title="ORDER_EMAIL_RECEIPT_MODAL.MODAL_TITLE">
        <div v-if="!orderIDForEmailReceipt"
             class="alert alert-danger">
            {{ l('ORDER_EMAIL_RECEIPT_MODAL.ORDER_CREATED_OFFLINE') }}
        </div>
        <form v-else
              class="form-v"
              @submit.prevent="ok">
            <div class="form-group">
                <label for="email">{{ l('ORDER_EMAIL_RECEIPT_MODAL.EMAIL_INPUT_LABEL') }}:</label>
                <input id="email"
                       v-model="email"
                       type="email"
                       class="form-control input-lg"
                       placeholder="Email" />
                <div v-if="error"
                     class="alert alert-danger mt-1">
                    <p>{{ error }}</p>
                </div>
            </div>
        </form>
    </Modal>
</template>

<script>
import Modal from '@/vue/components/Modals/Modal';
import { apiResponseToError } from '@/lib/Api';
import { container } from '@/container';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    components: { Modal },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        /**
         * @type {Order}
         */
        order: {
            type: Object,
            required: true,
        },
        originalOrderID: {
            type: Number,
            required: false,
            default: null,
        },
    },

    data() {
        return {
            email: this.getEmailFromOrder(),
            error: null,
            sending: false,
        };
    },

    computed: {
        /**
         * @return {number|null}
         */
        orderIDForEmailReceipt() {
            return (this.originalOrderID ? this.originalOrderID : this.order.ID);
        },

        /**
         * @return {boolean}
         */
        okEnabled() {
            return !!this.email && !!this.orderIDForEmailReceipt;
        },
    },

    methods: {
        getEmailFromOrder() {
            if (this.order && this.order.customer) {
                // From the OrderDetailsCtrl
                if (this.order.customer.contact && this.order.customer.contact.email) {
                    return this.order.customer.contact.email;
                }
                // From the ChangeCtrl
                if (this.order.customer.account
                    && this.order.customer.account.primaryContact
                    && this.order.customer.account.primaryContact.email
                ) {
                    return this.order.customer.account.primaryContact.email;
                }
            }
            return '';
        },

        ok() {
            if (this.sending) {
                return;
            }

            this.error = null;

            if (!this.email) {
                this.error = container.langService.getText('ORDER_EMAIL_RECEIPT_MODAL.EMAIL_REQUIRED_ERROR');
                return;
            }

            this.sending = true;

            container.orderResource.emailReceipt(
                {
                    id: this.orderIDForEmailReceipt,
                },
                {
                    email: this.email,
                },
                (response) => {
                    container.toastFactory.success(
                        'ORDER_EMAIL_RECEIPT_MODAL.SUCCESS_TOAST_TITLE',
                        container.langService.getText(
                            'ORDER_EMAIL_RECEIPT_MODAL.SUCCESS_TOAST_MESSAGE',
                            {
                                email: response.sentTo,
                            }
                        )
                    );
                    this.resolve();
                    this.sending = false;
                },
                (result) => {
                    this.error = apiResponseToError(result).message;
                    this.sending = false;
                }
            );
        },
    },
};
</script>
